import { usePostHog } from "@posthog/react";
import { LanguageSwitcher } from "@web/components/language-switcher";
import { Button } from "@web/components/ui/button";
import {
	NavigationMenu,
	NavigationMenuItem,
	NavigationMenuLink,
	NavigationMenuList,
} from "@web/components/ui/navigation-menu";
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTrigger,
} from "@web/components/ui/sheet";
import { getCurrentProduct } from "@web/config";
import { useLanguage } from "@web/lib/contexts/language-context";
import { useConsultation } from "@web/lib/hooks/consultations";
import { cn } from "@web/lib/utils";
import { Menu } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";

export function Nav() {
	const { t, language } = useLanguage();
	const { Logo } = getCurrentProduct();
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const posthog = usePostHog();
	const params = useParams();
	const { data } = useConsultation(params?.id as string);

	useEffect(() => {
		if (data?.id) {
			posthog?.identify(data?.id, {
				product: data?.product?.name,
			});
		}
	}, [posthog, data?.id, data?.product?.name]);

	return (
		<header className="sticky top-0 z-30 w-full bg-background border-b border-border shadow-sm backdrop-blur-sm">
			<div className="container mx-auto flex h-20 items-center justify-between px-4">
				<div className="flex items-center gap-2">
					<img
						src={Logo || "/placeholder.svg"}
						alt="Inmetro Logo"
						className="h-12"
					/>
				</div>

				<NavigationMenu className="hidden md:flex">
					<NavigationMenuList className="gap-2">
						<NavigationMenuItem asChild>
							<Link
								to="/faq"
								onClick={() => posthog.capture("clicked_faq", { language })}
								className={cn(
									"group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50",
								)}
							>
								{t.nav.faq}
							</Link>
						</NavigationMenuItem>
						<NavigationMenuItem>
							<NavigationMenuLink asChild>
								<Link
									to="/denunciar"
									className={cn(
										"group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50",
									)}
								>
									{t.nav.reportProblem}
								</Link>
							</NavigationMenuLink>
						</NavigationMenuItem>
						<NavigationMenuItem>
							<NavigationMenuLink asChild>
								<Link
									to="/contato"
									className={cn(
										"group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50",
									)}
								>
									{t.nav.contact}
								</Link>
							</NavigationMenuLink>
						</NavigationMenuItem>
					</NavigationMenuList>
				</NavigationMenu>

				<div className="flex items-center gap-4">
					<LanguageSwitcher />
					{/* <Link
						to="/entrar"
						className="hidden font-medium text-muted-foreground text-sm hover:text-primary md:block"
					>
						Entrar
					</Link>
					<Button asChild>
						<Link to="/cadastro">Cadastre-se</Link>
					</Button> */}

					<Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
						<SheetTrigger asChild className="md:hidden">
							<Button variant="ghost" size="icon" className="h-10 w-10">
								<Menu size={20} />
								<span className="sr-only">{t.nav.menu}</span>
							</Button>
						</SheetTrigger>
						<SheetContent
							side="right"
							className="w-[300px] sm:w-[400px] bg-background border-l border-border"
						>
							<SheetHeader className="border-b border-border pb-4">
								<Link
									to="/"
									onClick={() => setIsMenuOpen(false)}
									className="transition-opacity hover:opacity-80"
								>
									<img
										src={Logo || "/placeholder.svg"}
										alt="Inmetro Logo"
										className="h-12"
									/>
								</Link>
							</SheetHeader>
							<nav className="flex flex-col gap-2 p-6 pt-8">
								<Link
									to="/faq"
									onClick={() => setIsMenuOpen(false)}
									className="rounded-md px-2 py-2 text-sm font-medium hover:bg-accent"
								>
									{t.nav.faq}
								</Link>

								<Link
									to="/denunciar"
									onClick={() => setIsMenuOpen(false)}
									className="rounded-md px-2 py-2 text-sm font-medium hover:bg-accent"
								>
									{t.nav.reportProblem}
								</Link>

								<Link
									to="/contato"
									onClick={() => setIsMenuOpen(false)}
									className="rounded-md px-2 py-2 text-sm font-medium hover:bg-accent"
								>
									{t.nav.contact}
								</Link>
							</nav>
						</SheetContent>
					</Sheet>
				</div>
			</div>
		</header>
	);
}
